import { DATETIME_UNIT } from '@ricoh/ria.client.core/constants/core/unit';

/** Session duration. */
export const SESSION_DURATION = (60 - 5) * DATETIME_UNIT.MINUTE; // 60 minutes - 5 minutes for buffer

/** SessionTimeout counter initial value. */
export const SESSION_TIMEOUT_COUNTER_INITIAL_VALUE = 60;
